import { createRouter, createWebHistory } from 'vue-router'

// Importação do store de autenticação
import { useAuthStore } from '@/stores/auth'

// Importação de layouts
import LoginLayout from '@/layouts/Login.vue'
import DefaultLayout from '@/layouts/Default.vue'

// Importação de views
import LoginPage from '@/views/login/LoginPage.vue'
import DashboardPage from '@/views/application/DashboardPage.vue'
import ActivitiesPage from '@/views/application/ActivitiesPage.vue'
import UsersPage from '@/views/application/UsersPage.vue'

const routes = [
  // Template de login
  {
    path: '/login',
    component: LoginLayout,
    meta: { public: true },
    children: [
      {
        path: '',
        name: 'Login',
        component: LoginPage,
      },
    ],
  },
  // Template padrão
  {
    path: '/',
    component: DefaultLayout,
    meta: { public: false },
    children: [
      {
        path: '',
        name: 'DashboardPage',
        component: DashboardPage,
      },
      {
        path: '/atividades',
        name: 'ActivitiesPage',
        component: ActivitiesPage,
      },
      {
        path: '/usuarios',
        name: 'UsersPage',
        component: UsersPage,
        meta: { adminOnly: true }
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});
router.beforeEach((to, from, next) => {
  const auth = useAuthStore();
  const isPublic = to.meta.public;
  const isLogged = auth.initialized();

  // Se a rota não é pública e o usuário não está logado, redireciona para login
  if (!isPublic && !isLogged) {
    if (auth.user) auth.logout();
    return next('/login');
  }

  // Se a rota é pública, permite a navegação
  if (isPublic) return next();

  // Se o usuário está logado mas não temos os dados ainda, busca os dados
  if (isLogged && !auth.getUserData()?.id) {
    // Aguarda os dados do usuário serem carregados
    auth.fetchUser().then(() => {
      // Após carregar os dados, verifica novamente as permissões
      const userData = auth.getUserData();

      // Verifica se rota requer permissão específica
      if (to.meta.permission && !userData?.permissoes?.includes(to.meta.permission)) {
        return next(from.path || '/');
      }

      // Verifica se rota é só para admin (usando o campo correto 'admin')
      if (to.meta.adminOnly && userData?.admin !== '1') {
        return next(from.path || '/');
      }

      next();
    }).catch(() => {
      // Se falhar ao buscar dados do usuário, desloga
      auth.logout();
      return next('/login');
    });
    return;
  }

  const userData = auth.getUserData();

  // Verifica se rota requer permissão específica
  if (to.meta.permission && !userData?.permissoes?.includes(to.meta.permission)) {
    return next(from.path || '/');
  }

  // Verifica se rota é só para admin (usando o campo correto 'admin')
  if (to.meta.adminOnly && userData?.admin !== '1') {
    return next(from.path || '/');
  }

  next();
});

export default router

